import { j as n } from "../../../../_virtual/jsx-runtime.js";
import { cn as x } from "../../../../lib/utils.js";
const f = ({
  payload: e,
  className: i,
  config: t,
  formatter: c
}) => {
  const s = e == null ? void 0 : e.filter(({ value: l }) => l != null);
  return s != null && s.length ? /* @__PURE__ */ n.jsx("div", { className: x("flex flex-col gap-1", i), children: s == null ? void 0 : s.map(({ dataKey: l, value: o }) => {
    const r = l ? t[l] : null;
    return r ? /* @__PURE__ */ n.jsxs("div", { className: "flex flex-row gap-1", children: [
      /* @__PURE__ */ n.jsx(
        "div",
        {
          className: x("flex self-center rounded-full h-2.5 w-2.5 mr-1"),
          style: {
            backgroundColor: r.color
          }
        }
      ),
      /* @__PURE__ */ n.jsxs("span", { children: [
        r.shortLabel || r.label,
        ":"
      ] }),
      /* @__PURE__ */ n.jsxs("span", { children: [
        c ? c(o) : o,
        o !== "N/A" ? r.unit : null
      ] })
    ] }, l) : null;
  }) }) : /* @__PURE__ */ n.jsx(n.Fragment, {});
};
export {
  f as default
};
